import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgSettingsUserSetting({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M15.77 10.62L13.5 8.37c-.3-.3-.71-.47-1.13-.47h-1.99a.8.8 0 00-.8.8v1.98c0 .43.17.83.47 1.13l2.26 2.25a.8.8 0 001.13 0l2.31-2.3a.8.8 0 000-1.14zm-4.57-.52a.6.6 0 110-1.2.6.6 0 110 1.2zM5.6 7.9a3.2 3.2 0 100-6.4 3.2 3.2 0 000 6.4zm3.2 2.78V8.85c-.31-.09-.63-.15-.96-.15h-.42a4.36 4.36 0 01-3.64 0h-.42A3.36 3.36 0 000 12.05v1.04c0 .66.54 1.2 1.2 1.2H10c.39 0 .73-.19.95-.48L9.5 12.38a2.38 2.38 0 01-.7-1.7z" />
    </svg>
  );
}

SvgSettingsUserSetting.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgSettingsUserSetting.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgSettingsUserSetting svgRef={ref} {...props} />
));
export default ForwardRef;
